export const eLetterParamsAP: (Submodule: any) => string[] = (submodule) => {
    let eLetterParamsArray: string[] = []

    //==================================================================//
    //==================================================================//
    //================CREDITOR & HEADER LEVEL PARAMETERS================//
    //==================================================================//
    //==================================================================//
    const commonCreditorParams: string[] = [
        '[CreditorName]',
        '[CreditorAddress]',
        '[CreditorContactName]',
        '[CreditorContactNo]',
        '[CreditorContactEmail]',
        '[CreditorCompanyRegNo]',
        '[CreditorBankAccName]',
        '[CreditorBankAccNo]',
        '[CreditorTIN]',
        '[CreditorSSTRegNo]',
        '[CreditorGSTRegNo]',
        '[QRCode]',
    ]
    const commonHeaderParams: string[] = [
        // Left Header info
        '[Description]',
        '[Remark]',
        // Right Header Info
        '[DocumentNo]',
        '[DocumentDate]',
        '[ReferenceNo]',
        '[RefundMethod]',
        '[ChequeNo]',
        '[CompanyBankAccCode]',
        '[CompanyBankAccNo]',
    ]


    //=====================================================//
    //=====================================================//
    //================ITEM LEVEL PARAMETERS================//
    //=====================================================//
    //=====================================================//
    //>>>>> AP CREDIT NOTE & DEBIT NOTE <<<<<//
    const apCNDNItemLevelParams: string[] = [
        '[Index]',
        '[ItemRemark]',
        '[ItemTaxExemptionAmount]',
        '[ItemTaxExemptionRate]',
        '[ItemTaxExemptionReason]',
        '[TaxRate]',
        '[BaseAmt]',
        '[TaxAmt]',
        '[TotalAmt]',
    ]
    const apCNDNAllocationLevelParams: string[] = [
        '[AllocIndex]',
        '[AllocDocDate]',
        '[AllocDocNo]',
        '[AllocDesc]',
        '[AllocAmt]',
    ]

    //>>>>> AP PAYMENT ITEM AND ALLOCATION <<<<<//
    const apPaymentItemLevelParams: string[] = [
        '[Index]',
        '[AllocationDocDate]',
        '[AllocationDocNo]',
        '[AllocationRefNo]',
        '[AllocationDescription]',
        '[AllocationAmt]',
        '[AllocDefaultAmt]',
    ]
    const apPaymentAllocationLevelParams: string[] = [
        '[SubItemIndex]',
        '[AllocatedDetail]',
        '[AllocatedDocAmt]',
    ]

    //>>>>> AP REFUND ALLOCATION <<<<<//
    const apRefundAllocationLevelParams: string[] = [
        '[AllocationDocDate]',
        '[AllocationDocNo]',
        '[AllocationRefNo]',
        '[AllocationRemark]',
        '[AllocationAmt]',
    ]

    //========================================================//
    //========================================================//
    //================SUMMARY LEVEL PARAMETERS================//
    //========================================================//
    //========================================================//
    //>>>>> AP CREDIT NOTE & DEBIT NOTE <<<<<//
    const apCNDNSummaryParams: string[] = [
        '[SumBaseAmt]',
        '[SumTaxAmt]',
        '[SumTotalAmt]'
    ]

    //>>>>> AP PAYMENT <<<<<//
    const apPaymentSummaryParams: string[] = [
        '[SumAllocationAmt]',
        '[SumAllocationAmtWord]',
    ]

    //===============================================//
    //===============================================//
    //================RETURN FUNCTION================//
    //===============================================//
    //===============================================//
    switch (submodule) {
        case 'ADVANCE':
            return eLetterParamsArray = [
                '[DocumentNo]',
                '[DocumentDate]',
                '[ReferenceNo]',
                '[Description]',
                '[Remark]',
                '[TotalAmt]',
                '[SumTotalAmt]',
                '[SumAmtWords]',
                '[PaymentMethod]',
                '[ChequeNo]',
                '[CompanyBankAccCode]',
                '[CompanyBankAccNo]',
            ]

        case 'CREDIT_NOTE':
            return eLetterParamsArray = [
                ...commonCreditorParams,
                ...commonHeaderParams,
                ...apCNDNItemLevelParams,
                ...apCNDNAllocationLevelParams,
                ...apCNDNSummaryParams
            ]

        case 'DEBIT_NOTE':
            return eLetterParamsArray = [
                ...commonCreditorParams,
                ...commonHeaderParams,
                ...apCNDNItemLevelParams,
                ...apCNDNSummaryParams
            ]


        case 'PAYMENT':
            return eLetterParamsArray = [
                ...commonCreditorParams,
                ...commonHeaderParams,
                ...apPaymentItemLevelParams,
                ...apPaymentAllocationLevelParams,
                ...apPaymentSummaryParams
            ]

        case 'REFUND':
            return eLetterParamsArray = [
                ...commonCreditorParams,
                ...commonHeaderParams,
                ...apRefundAllocationLevelParams,
                ...apPaymentSummaryParams
            ]
    }
}